
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs",
      function () {
        return require("private-next-pages/jobs/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs"])
      });
    }
  